module.exports = __webpack_public_path__ + "static/media/taro1.dfebfe13.jpg";